<template lang="pug">
    ApolloQuery(:query="require('./graphql/Navigation.gql')", :variables="{ locale: $route.params.locale }")
        template(slot-scope="{ result: { data, loading }, isLoading}")
            Loading(:active="isLoading", :full-page="false")
            #app(v-if="data", :style="{'padding-top':onMobile.active ?  '82px' : '0'}")
                notifications(group="errors", position="bottom right", width="500", class="notify__errors")
                .container.header
                    .row.header__inner
                        .logo.col-3.col-md-2
                            router-link.logo__link(:to="homepage")
                                img.logo__img(v-bind='data.navigation.icon', width="90")
                        .col-3.d-lg-none(v-if="menu")
                            a.nav__link(:href='switchLanguage', @click="closeMenu()") {{nextLanguage}}
                        .nav.col-12.col-md-10(:class="{'nav-active':menu}")
                            .nav__item(@click="closeMenu()").d-block.d-lg-none
                                router-link.nav__link(v-bind:to='homepage')
                                    img(src="./assets/home/nav__menu-home.png"
                                        srcset="./assets/home/nav__menu-home.png, ./assets/home/nav__menu-home@2x.png 2x, ./assets/home/nav__menu-home@3x.png 3x").d-inline.d-lg-none
                                    span(v-if="$route.params.locale == 'zh' || !$route.params.locale") 主頁
                                    span(v-if="$route.params.locale == 'en'") Homepage
                            .nav__item(v-for="(repeater, index) in data.navigation.navigation_items", @click="closeMenu()")
                                router-link.nav__link(v-bind:to='url(repeater.url)')
                                    img(v-if="index == 0",
                                        src="./assets/home/nav__menu-jobs.png"
                                        srcset="./assets/home/nav__menu-jobs.png, ./assets/home/nav__menu-jobs@2x.png 2x, ./assets/home/nav__menu-jobs@3x.png 3x").d-inline.d-lg-none
                                    img(v-if="index == 1",
                                        src="./assets/home/nav__menu-career.png"
                                        srcset="./assets/home/nav__menu-career.png, ./assets/home/nav__menu-career@2x.png 2x, ./assets/home/nav__menu-career@3x.png 3x").d-inline.d-lg-none
                                    img(v-if="index == 2",
                                        src="./assets/home/nav__menu-benifit.png"
                                        srcset="./assets/home/nav__menu-benifit.png, ./assets/home/nav__menu-benifit@2x.png 2x, ./assets/home/nav__menu-benifit@3x.png 3x").d-inline.d-lg-none
                                    span.nav__link__child(v-text="repeater.title")
                            .nav__item(@click="closeMenu()")
                                a.nav__link(:href='switchLanguage') {{nextLanguage}}
                        .nav__menu.d-lg-none.d-xl-none
                            button(type="button", @click="toggleMenu()").nav__button
                                img(v-if="!menu",
                                    src="./assets/home/nav__menu.png"
                                    srcset="./assets/home/nav__menu.png, ./assets/home/nav__menu@2x.png 2x, ./assets/home/nav__menu@3x.png 3x")
                                img(v-if="menu",
                                    src="./assets/home/nav__menu-close.png"
                                    srcset="./assets/home/nav__menu-close.png, ./assets/home/nav__menu-close@2x.png 2x, ./assets/home/nav__menu-close@3x.png 3x")
                .main
                    router-view(:locale="'zh'")
                .container-fluid.footer.page-bottom
                    .row.footer__inner
                        .col-12
                            a.home_btn(:href="home.href", v-text="home.name", v-if="false")
                            a.home_btn(:href="declaration.href", v-text="declaration.name", target="_blank")
                            a.home_btn(:href="security.href", v-text="security.name", target="_blank")
                            .copyright {{ data.navigation.copyrights }}
</template>

<script>
    import Loading from "./components/Loading";

    export default {
        props: {
            locale: String,
        },
        components: {
            Loading
        },
        data() {
            return {
                menu: false
            }
        },
        computed: {
            home: function () {
                return this.$route.params.locale !== 'en' ? {
                    name: '安信主頁',
                    href: 'https://www.primecredit.com/'
                } : {
                    name: 'Homepage',
                    href: 'https://www.primecredit.com/'
                }
            },
            security: function () {
                const getHref = (locale) => `/career/documents/online_security_${locale}.pdf`;
                return this.$route.params.locale !== 'en' ? {
                    name: '網上保安提示',
                    href: getHref('zh')
                } : {
                    name: 'Online Security',
                    href: getHref('en')
                }
            },
            declaration: function () {
                const getHref = (locale) => `/career/documents/website_declaration_${locale}.pdf`;
                return this.$route.params.locale !== 'en' ? {
                    name: '網頁聲明',
                    href: getHref('zh'),
                }: {
                    name: 'Website Declaration',
                    href: getHref('en')
                }
            },
            onMobile: function () {
                return {
                    'active': window.innerWidth < 1024
                };
            },
            homepage: function () {
                return `/${this.$route.params.locale || ''}`
            },
            switchLanguage: function () {
                this.closeMenu();
                const current = this.$route.params.locale;
                let path;
                if (current === 'en')
                    path = this.$route.path.replace('en', '').replace(/\/+/, '/');
                else if (current === 'zh')
                    path = this.$route.path.replace('zh', 'en');
                else
                    path = `/en${this.$route.path}`;

                return `/career${path}`;
            },
            nextLanguage: function () {
                return this.$route.params.locale === 'en' ? '中文' : 'ENG'
            }
        },
        methods: {
            toggleMenu: function () {
                this.$set(this, 'menu', !this.menu);
            },
            closeMenu: function () {
                this.$set(this, 'menu', false);
            },
            url: function (path) {
                const {locale} = this.$route.params;
                const prefix = locale ? `${locale}/` : '';
                return `/${prefix}${path}`
            }
        },
    }
</script>

<style lang="sass">
    @import "../node_modules/bootstrap/scss/functions";
    @import "./assets/styles/_CustomVariables";
    @import "./assets/styles/_common.sass";
    @import "./assets/styles/wysiwyg";
    @import "../node_modules/bootstrap/scss/variables";
    @import "../node_modules/bootstrap/scss/mixins";
    @import "../node_modules/bootstrap/scss/reboot";
    @import "../node_modules/bootstrap/scss/utilities/display";
    @import "../node_modules/bootstrap/scss/utilities/text";
    @import "../node_modules/bootstrap/scss/grid";
    $white: #ffffff
    $color-text: #333333

    .main
        padding-top: 106px
        @include media-breakpoint-down(md)
            padding-top: 0
        padding-bottom: 6rem
        overflow: hidden

    #app
        font-family: Helvetica, Arial, "Microsoft JhengHei", "微軟正黑體", sans-serif
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale
        font-size: 100%
        color: $color-text

        img
            max-width: 100%

    input
        font-family: Helvetica, Arial, "Microsoft JhengHei", "微軟正黑體", sans-serif
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale
        font-size: 100%

    .header
        overflow: visible
        padding: 1rem 0
        background: #ffffff
        position: fixed
        top: 0
        left: 0
        z-index: 999
        max-width: none
        width: 100%
        @include media-breakpoint-down(md)
            padding: 1rem 15px

        &__inner
            margin: auto
            max-width: 1400px
            @include media-breakpoint-down(lg)
                max-width: 900px
            align-items: center

    .loading
        padding: 5rem 0
        text-align: center
        font-size: 5rem
        @include media-breakpoint-down(md)
            font-size: 1.5rem

    .logo
        &__img
            @include media-breakpoint-down(md)
                width: auto
                max-width: none !important
                height: 50px

    .footer
        background: #898989

        &__inner
            color: white
            @extend .container
            padding-top: 1.5rem
            padding-bottom: 1.5rem
            margin: 0 auto
            @include media-breakpoint-down(md)
                padding-left: 0
                padding-right: 0
            @include media-breakpoint-down(sm)
                text-align: center
                font-size: 3vw

        @include media-breakpoint-down(md)
            padding-left: 0
            padding-right: 0

    .home_btn
        color: $white
        margin-right: 0
        &:not(:first-child):before
            display: inline-block
            content: "|"
            margin: 0 1.5vw
        @include media-breakpoint-down(sm)
            margin-right: 0

        &:hover
            color: $white
            text-decoration: none

    .copyright
        color: $white
        float: right
        @include media-breakpoint-down(sm)
            margin-top: .5vw
            float: none

    .nav
        padding: 1rem 0
        text-align: right
        font-size: 0
        @include media-breakpoint-down(md)
            position: absolute
            top: 100%
            right: 0
            display: none
            width: 80%
            max-width: none
            background: #f9f9f9
            &-active
                display: block

        &__item
            display: inline-block
            position: relative
            font-size: 1rem
            padding: 0 2rem
            @include media-breakpoint-down(md)
                width: 100%
                padding: 0 2rem
                text-align: left
            > *
                @include media-breakpoint-down(md)
                    vertical-align: baseline
            img
                @include media-breakpoint-down(md)
                    margin-right: 1rem
                    transform: scale(.5)
            a
                @include media-breakpoint-down(md)
                    display: inline-block
                    width: 100%
                    border-bottom: 1px solid #009734
                    padding: 1rem 0

            &:nth-last-child(2)
                a
                    @include media-breakpoint-down(md)
                        border-bottom: none
            &:last-child
                a
                    @include media-breakpoint-down(md)
                        display: none !important

            &:first-child
                a
                    @include media-breakpoint-down(md)
                        padding-top: 0

            &:first-child
                padding-left: 0
                @include media-breakpoint-down(md)
                    padding-left: 2rem

            &:last-child
                padding-right: 0
                @include media-breakpoint-down(md)
                    padding-right: 2rem

            &:after
                content: ''
                display: inline-block
                position: absolute
                top: 25%
                right: 0
                width: 1px
                height: 50%
                background: #333333
                @include media-breakpoint-down(md)
                    display: none

            &:last-child:after
                display: none

        &__link,
        &__link:visited
            color: #333333

        &__link
            @include media-breakpoint-down(md)
                display: flex !important
                align-items: center
                img
                    width: 27%
                    margin: 0
                    padding-right: 1rem
                &__child
                    float: right
                    width: 72%


        &__button
            position: absolute
            top: 50%
            right: 15px
            background: none
            border: none
            transform: scale(.5) translateY(-100%)
            transform-origin: 50% 50%

            &:focus
                outline: 0

</style>
